import { createSettingsParams, SettingsParamType } from '@wix/tpa-settings';
import { DataType } from '@wix/editor-platform-ooi-metadata-resolver';

export type TextSettingsParams = {
  headerTitle: SettingsParamType.Text;
  headerDescription: SettingsParamType.Text;
  addToCartButtonText: SettingsParamType.Text;
};

/**
 * `metadata` exposes these params in the widget's editor manifest
 * (`editorElement.data`), which is what Aria reads and edits in Studio 2.
 * Params without `metadata` are dropped from the manifest.
 * `displayName` is the field label in the Studio 2 "Edit Text" panel.
 */
export const textSettingsParams = createSettingsParams<TextSettingsParams>({
  headerTitle: {
    type: SettingsParamType.Text,
    getDefaultValue: () => '',
    metadata: ({ t }) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('header_olo.default.title'),
      },
      dataItemManifestData: {
        displayName: t('app.settings.text.title'),
      },
      ai: {
        description:
          'Title text shown at the top of the Online Orders widget header. An empty value does not hide the title: ' +
          'it shows the default title instead. To hide or show the title, set showHeaderTitle.',
      },
    }),
  },
  headerDescription: {
    type: SettingsParamType.Text,
    getDefaultValue: () => '',
    metadata: ({ t }) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('header_olo.default.description'),
      },
      dataItemManifestData: {
        displayName: t('app.settings.text.description'),
      },
      ai: {
        description:
          'Description text shown under the title in the Online Orders widget header. An empty value does not hide ' +
          'the description: it shows the default description instead. To hide or show it, set showHeaderDescription.',
      },
    }),
  },
  addToCartButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: () => '',
    metadata: ({ t }) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('menu_olo.addToCartButton.default-text'),
      },
      dataItemManifestData: {
        displayName: t('app.settings.design-tab.add-to-cart.title'),
      },
      ai: {
        description:
          'Text of the add to cart button on menu items. Never set it to an empty value: that does not hide ' +
          'the button, it leaves a button without a label. To hide or show the button, set showAddToCartButton.',
      },
    }),
  },
});
